import {
  ToolbarGroup,
  Button as WPButton,
} from "@wordpress/components";
import {
  useBlockProps,
  BlockControls,
  RichText,
} from "@wordpress/block-editor";
import { TextControl } from "@wordpress/components";
import { useState, useEffect, useCallback } from "@wordpress/element";
import SidePanel from "./button-sidePanel";
import { handleUrlChange2, sanitizeInput, sanitizeKeepHTML, isValidDomain } from '../utilities/helpers';
import { t } from "drupal";


function Edit({ attributes = {}, setAttributes, isSelected }) {
  // Define attributes
  const {
    linkText = '',
    linkUrl = '',
    linkOnlyColorClass = '',
    backgroundColorClass = '',
    size = 'btn-md',
    ariaLabel = '',
    ctaError = false,
    ctaUrlError = false,
  } = attributes;

  // Check if size is 'link'
  const isLinkOnly = size === 'link';

  // Determine class name based on whether it's a button or a link
  const baseClass = isLinkOnly
    ? `link-only ${linkOnlyColorClass}`
    : `button ${backgroundColorClass}`;

  // Determine class name based on size
  const sizeClass = isLinkOnly
    ? 'btn-link'
    : `btn btn-primary mdbtn ${size || 'btn-md'}`;

  // Handle background color change
  const onChangeBackgroundColorClass = (className) =>
    setAttributes({ backgroundColorClass: className });


  // Handle linkOnly color change
  const onChangeLinkOnlyColor = (newColor) => {
    setAttributes({ linkOnlyColor: newColor });
  };

  const onChangeSize = (newSize) => {
    setAttributes({ size: newSize });
  };

  // Strip out HTML and script for CTA text
  const onChangeCTA = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ linkText: cleanedText });
  };

  // Strip out HTML and script for CTA URL
  const onChangeCTAUrl = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ linkUrl: cleanedText });
  };




 /**
 * If the user presses Enter or Tab, update the URL
 **/

  const handleKeyDown = useCallback((event) => {
    if ((event.key === 'Enter' || event.key === 'Tab') && linkUrl) {
      //handleUrlChange2 is from /deohs_gutenberg_blocks/blocks/utilities/helpers.js
      const updatedUrl = handleUrlChange2(linkUrl);
      if (updatedUrl !== linkUrl) { // Prevent unnecessary updates
        setAttributes({ linkUrl: updatedUrl });
      }
    }
  }, [linkUrl, setAttributes]);

  /**
  * Central validation logic
  **/

  useEffect(() => {
    const ctaError = !linkText?.trim();
    const ctaUrlError = !isValidDomain(linkUrl);

    // console.log('setAttributes in button edit.js', { ctaError, ctaUrlError });

    setAttributes({
      ctaError,
      ctaUrlError,
    });
  }, [linkText, linkUrl]);



  return (
    <div {...useBlockProps()}>
      {/* Toolbar */}
      <BlockControls>
        <ToolbarGroup>
          <WPButton
            label={t('Button Settings')}
            icon="admin-links"
            disabled
          />
        </ToolbarGroup>
      </BlockControls>

      {/* Side panel for settings */}
      <SidePanel
        linkUrl={linkUrl}
        linkText={linkText}
        size={size}
        onChangeCTA={onChangeCTA}
        onChangeCTAUrl={onChangeCTAUrl}
        onChangeSize={onChangeSize}
        backgroundColorClass={backgroundColorClass}
        linkOnlyColorClass={linkOnlyColorClass}
        onChangeBackgroundColorClass={onChangeBackgroundColorClass}
        ariaLabel={ariaLabel}
        setAttributes={setAttributes}
      />


      {/* Show error message in red text above button if invalid */}
      {(ctaError || ctaUrlError) && (
        <div className="editor-field-error-message">
          {ctaError && ctaUrlError
            ? t("Button text and Valid URL are required")
            : ctaError
              ? t("Button text is required")
              : ctaUrlError
                ? t("Valid URL is required")
                : ""}
        </div>
      )}


      {/* Button preview with error highlighting */}
      <div>
        <div
          className={`${baseClass} ${sizeClass} ${ctaError ? "is-required" : ""}`}
        >
            <TextControl
              value={linkUrl}
              onChange={onChangeCTAUrl}
            className={`btn-link button-url ${ctaUrlError ? "is-required" : ""}`}
              style={{
                border: ctaUrlError ? "2px solid red" : "2px solid black",
                background: "white"
              }}
              onBlur={() => {
                if (linkUrl) {
                  const updatedUrl = handleUrlChange2(linkUrl);
                  if (updatedUrl !== linkUrl) {
                    setAttributes({ linkUrl: updatedUrl });
                  }
                }
              }}
              onKeyDown={handleKeyDown}
              placeholder={t("/about or example.com")}

            />

            <TextControl
              value={linkText}
              onChange={onChangeCTA}
              style={{
                backgroundColor: "white",
                color: "black",
                border: ctaError ? "2px solid red" : "2px solid black",
              }}
              placeholder={t("Call to action text")}
            />
        </div>
      </div>
    </div>
  );
}

export default Edit;
